import invert from "lodash/invert";
export var Family = {
    serif: "Nantes, serif",
    sansSerif: "Graphik, sans-serif",
    /** @deprecated use Family.serif instead. */ bigCaslon: "Big Caslon, serif"
};
export var Weight = {
    thin: "100",
    book: "200",
    light: "300",
    medium: "400",
    bold: "700"
};
/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */ export var getFontFamilyWithWeight = function(family, weight) {
    var fontFamilyBase = family === Family.serif ? "Sentinel" : family === Family.sansSerif ? "GothamSSm" : "BigCaslon";
    var _invert_;
    var weightSuffix = (_invert_ = invert(Weight)["".concat(weight)]) !== null && _invert_ !== void 0 ? _invert_ : "medium";
    return "".concat(fontFamilyBase, "-").concat(weightSuffix.charAt(0).toUpperCase()).concat(weightSuffix.slice(1), ", ").concat(family);
};
/** @deprecated This is an old font. Use Alphabet Soup fonts instead */ export var mediumBigCaslon = getFontFamilyWithWeight(Family.bigCaslon, Weight.medium);
/** @deprecated This is an old font. Use Alphabet Soup fonts instead */ export var lightSentinel = getFontFamilyWithWeight(Family.serif, Weight.light);
/** @deprecated This is an old font. Use Alphabet Soup fonts instead */ export var bookSentinel = getFontFamilyWithWeight(Family.serif, Weight.book);
/** @deprecated This is an old font. Use Alphabet Soup fonts instead */ export var mediumSentinel = getFontFamilyWithWeight(Family.serif, Weight.medium);
/** @deprecated This is an old font. Use Alphabet Soup fonts instead */ export var bookGotham = getFontFamilyWithWeight(Family.sansSerif, Weight.book);
/** @deprecated This is an old font. Use Alphabet Soup fonts instead */ export var mediumGotham = getFontFamilyWithWeight(Family.sansSerif, Weight.medium);
/** @deprecated This is an old font. Use Alphabet Soup fonts instead */ export var boldGotham = getFontFamilyWithWeight(Family.sansSerif, Weight.bold);
